import { Container, Eyebrow } from "@constructorfleet/ui/design-system";

export function RefundPolicyPage() {
  return (
    <div className="policy-page">
      <section className="ph">
        <Container>
          <Eyebrow brand dot>
            Legal
          </Eyebrow>
          <h1>Refund Policy</h1>
          <p className="lede">Last updated March 23, 2026</p>
        </Container>
      </section>

      <section className="policy-body">
        <Container small>
          <section className="policy-section">
            <h2>Payment Processing</h2>
            <p>
              Payments for ConstructorFleet subscriptions are processed by Paddle, who acts as the
              authorized reseller and Merchant of Record for all transactions. Purchases are subject
              to both this policy and{" "}
              <a href="https://www.paddle.com/legal/buyer-terms" target="_blank" rel="noreferrer">
                Paddle&rsquo;s Buyer Terms
              </a>
              . ConstructorFleet services are available to customers in the United States only.
            </p>
          </section>

          <section className="policy-section">
            <h2>Standard Cancellations</h2>
            <p>
              You may cancel your subscription at any time through your account settings or by
              contacting us. Upon cancellation, your subscription remains active through the end of
              the current billing period and will not renew. No refund is issued for the remaining
              days in the billing period under a standard cancellation.
            </p>
          </section>

          <section className="policy-section">
            <h2>Immediate Cancellation &amp; Prorated Refunds</h2>
            <p>
              If you prefer your cancellation to take effect immediately rather than at the end of
              the billing period, you may request an immediate cancellation. In that case, we will
              issue a prorated refund for the unused portion of the current billing period,
              calculated as:
            </p>
            <p>
              <strong>
                Refund = (days remaining in billing period / total days in billing period) &times;
                amount paid
              </strong>
            </p>
            <p>
              Requests for immediate cancellation and prorated refunds must be submitted within{" "}
              <strong>14 days of the most recent billing date</strong>. Requests submitted after
              that window will be treated as standard cancellations effective at the end of the
              current billing period.
            </p>
            <p>
              Add-on subscriptions are refunded on the same prorated basis when cancelled alongside
              the main subscription. Add-ons cannot be refunded independently of the main
              subscription.
            </p>
          </section>

          <section className="policy-section">
            <h2>Non-Refundable Circumstances</h2>
            <p>
              Refunds will not be issued where there is evidence of fraud, refund abuse, or
              violation of our Terms &amp; Conditions. Paddle may decline refund requests on these
              grounds in accordance with their Buyer Terms.
            </p>
          </section>

          <section className="policy-section">
            <h2>How to Request a Cancellation or Refund</h2>
            <p>
              To cancel your subscription or request an immediate cancellation refund, contact us at{" "}
              <a href="mailto:support@constructorfleet.com?subject=Cancellation%20Request">
                support@constructorfleet.com
              </a>
              . You may also manage your subscription through your account settings or via the link
              in your Paddle receipt email.
            </p>
            <p>
              Approved refunds are processed through your original payment method within 14 days of
              approval.
            </p>
          </section>
        </Container>
      </section>
    </div>
  );
}
